import { useEffect, useState } from "react";

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

const DISMISSED_KEY = "pwa_install_dismissed";

export function PWAInstallBanner() {
  const [prompt, setPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISSED_KEY)) return;

    const handler = (e: Event) => {
      e.preventDefault();
      setPrompt(e as BeforeInstallPromptEvent);
      setVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!visible || !prompt) return null;

  async function handleInstall() {
    if (!prompt) return;
    await prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setVisible(false);
  }

  function handleDismiss() {
    sessionStorage.setItem(DISMISSED_KEY, "1");
    setVisible(false);
  }

  return (
    <div
      role="banner"
      className="fixed bottom-4 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 items-center gap-3 rounded-xl border border-black/[0.08] dark:border-white/[0.08] bg-white dark:bg-[#14171c] px-4 py-3 shadow-lg dark:shadow-none sm:bottom-6"
    >
      <img src="/agentic-league.svg" alt="" className="h-9 w-9 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-[13px] font-bold text-foreground dark:text-white leading-tight">
          Agentic League
        </p>
        <p className="text-[11px] text-foreground/55 dark:text-white/55 leading-tight mt-0.5">
          Instale para acesso rápido
        </p>
      </div>
      <button
        type="button"
        onClick={handleInstall}
        className="shrink-0 rounded-lg bg-coral px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-white hover:bg-coral/90"
      >
        Instalar
      </button>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Fechar"
        className="shrink-0 text-foreground/40 dark:text-white/40 hover:text-foreground dark:hover:text-white text-lg leading-none"
      >
        ×
      </button>
    </div>
  );
}
